export const ROLE_PERMS = {
  sections: ["super_admin", "content_manager"],
  news: ["super_admin", "content_manager"],
  trading_ideas: ["super_admin", "content_manager"],
  education: ["super_admin", "content_manager"],
  faq: ["super_admin", "content_manager", "support_manager"],
  promotions: ["super_admin", "marketing_manager"],
  testimonials: ["super_admin", "marketing_manager"],
  links: ["super_admin", "marketing_manager"],
  media: ["super_admin", "content_manager", "marketing_manager"],
  events: ["super_admin", "content_manager"],
  videos: ["super_admin", "content_manager"],
  hero_slides: ["super_admin", "content_manager", "marketing_manager"],
  menu: ["super_admin", "content_manager"],
  seo: ["super_admin", "content_manager"],
  settings: ["super_admin", "content_manager"],
  pages: ["super_admin", "content_manager"],
  contacts: ["super_admin", "support_manager"],
  users: ["super_admin"],
  audit: ["super_admin", "content_manager", "marketing_manager", "support_manager"],
  dashboard: ["super_admin", "content_manager", "marketing_manager", "support_manager"],
};

export function canAccess(role, resource) {
  const allowed = ROLE_PERMS[resource];
  return !allowed || allowed.includes(role);
}
